'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moment = require('moment-timezone');

var Timestamp = function () {
  function Timestamp() {
    _classCallCheck(this, Timestamp);

    this.format = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    this.timezone = 'Asia/Shanghai';
    this.unit = 's';
  }

  _createClass(Timestamp, [{
    key: 'setFormat',
    value: function setFormat(format) {
      this.format = format;
    }
  }, {
    key: 'setTimezone',
    value: function setTimezone(timezone) {
      this.timezone = timezone;
    }
  }, {
    key: 'setUnit',
    value: function setUnit(unit) {
      unit = unit ? unit.toLowerCase() : 's';
      this.unit = unit === 'ms' || unit === 's' ? unit : 's';
    }
  }, {
    key: 'current',
    value: function current() {
      return Math.floor(Date.now() / (this.unit === 'ms' ? 1 : 1000));
    }
  }, {
    key: 'fromDate',
    value: function fromDate(date) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var unit = options.unit ? options.unit : this.unit;
      return Math.floor(date.getTime() / (unit === 'ms' ? 1 : 1000));
    }
  }, {
    key: 'toDate',
    value: function toDate(timestamp) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var unit = options.unit ? options.unit : this.unit;
      return new Date(timestamp * (unit === 'ms' ? 1 : 1000));
    }
  }, {
    key: 'fromDatetimeString',
    value: function fromDatetimeString(datetimeString) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var format = options.format ? options.format : this.format;
      var timezone = options.timezone ? options.timezone : this.timezone;
      var unit = options.unit ? options.unit : this.unit;
      return parseInt(moment(datetimeString, format).tz(timezone).format(unit === 'ms' ? 'x' : 'X'));
    }
  }, {
    key: 'toDatetimeString',
    value: function toDatetimeString(datetimeTimestamp) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var format = options.format ? options.format : this.format;
      var timezone = options.timezone ? options.timezone : this.timezone;
      return moment.unix(parseInt(datetimeTimestamp, 10)).tz(timezone).format(format);
    }
  }]);

  return Timestamp;
}();

var timestamp = new Timestamp();

module.exports = timestamp;